import { initBlockPodcast } from "./components/BlockPodcast";
import { initConfirmDeletionModal } from "./components/ConfirmDeletionModal";
import { initCreatePodcast } from "./components/podcast/CreatePodcast";
import { initDeletePodcast } from "./components/DeletePodcast";
import { initHeaderMenu } from "./components/header/HeaderMenu";
import { initHeaderMenuPrefix } from "./components/header/bootstrap/HeaderMenuPrefix";
import { initSearchEpisode } from "./components/SearchEpisode";
import { initSearchPodcastToImport } from "./components/importer/SearchPodcastToImport";
import { initSelectSinglePlayer } from "./components/SelectSinglePlayer";
import { initSspUserAlert } from "./components/SspUserAlert";
import { initEpisodeLinks } from "./components/EpisodeLinks";
import { initDeleteInvite } from "./components/DeleteInvite";
import { initSendInvite } from "./components/SendInvite";
import { initBarChart } from "./components/analytics/charts/BarChart";

export default () => {
  initBlockPodcast();
  initConfirmDeletionModal("[data-react-component='confirm-deletion-modal']");
  initCreatePodcast();
  initDeletePodcast();
  initHeaderMenu("[data-react-component='header-menu']");
  initHeaderMenuPrefix("[data-react-component='header-menu-prefix']");
  initSearchEpisode("[data-react-component='search-episode']");
  initSearchPodcastToImport(
    "[data-react-component='search-podcast-to-import']"
  );
  initSelectSinglePlayer("[data-react-component='select-single-player']");
  initSspUserAlert("[data-react-component='ssp-user-alert']");
  initEpisodeLinks('[data-react-component="episode-links"]');
  initDeleteInvite('[data-react-component="delete-invite"]');
  initSendInvite('[data-react-component="send-invite"]');
  initBarChart('[data-react-component="bar-chart"]');
};
